import { Btn, DropdownItem } from '.';

export class Dropdown {
  button?: Btn;
  list: DropdownItem[];
}
